import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';

import { AdminPage } from '../lib/admin_layout';
import KnowledgeBaseAdmin from './knowledge_base_admin';

const KnowledgeBaseAdminPage = createReactClass({
  mixins: [Morearty.Mixin],

  render() {
    return (
      <AdminPage id="knowledgeBaseAdmin-page" className="knowledgeBaseAdmin-page">
        <KnowledgeBaseAdmin />
      </AdminPage>
    );
  },
});

export default KnowledgeBaseAdminPage;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/knowledge_base/knowledge_base_admin_page.jsx